import React, { useMemo } from 'react';
import FilterSelect from './FilterSelect';
import { formatSubjectName } from '../utils/formatSubjectName';

type Subject = { id: number | string; name: string | null | undefined };

type Props = {
  subjects: Subject[];
  value: string;
  onChange: (subjectId: string) => void;
  placeholder?: string;
};

const SubjectFilterSelect: React.FC<Props> = ({
  subjects,
  value,
  onChange,
  placeholder = 'Все предметы',
}) => {
  const options = useMemo(
    () =>
      subjects.map((s) => ({
        value: String(s.id),
        label: formatSubjectName(s.name),
      })),
    [subjects]
  );

  return (
    <FilterSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default SubjectFilterSelect;
